import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDetailsItemLoader',
  props: {
    dense: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})